import {
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Grid,
  Card,
  CardContent,
  useTheme,
} from "@mui/material";//FB 6997  //FB 7541
import { Delete } from "@mui/icons-material";//FB 7541
import {
  Button,
  TextField,
  ThemeProvider,
  createTheme,
  IconButton,
  Typography,
  TableContainer,
  Select,
  InputLabel,
  MenuItem,
  Tooltip,
  DialogTitle,
  Dialog,
  DialogContent,
  CircularProgressProps,
  CircularProgress,
  DialogActions,
  FormControl,
} from "@material-ui/core";//FB 7541
import VaccinesIcon from "@mui/icons-material/Vaccines";
import InfoIcon from "@mui/icons-material/Info";
import CancelIcon from "@mui/icons-material/Cancel";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  GetCCDA,
  GetCCDAHTML,
  GetMedications,
  GetPharmacy,
  InsertPPLogs,
  UpdatePharmacyDetails,
  GetDocumentCategories
} from "../../../../api"; //FB 9372
import NavBar from "../../../../components/Navbar";
import { CCDA, Medication, SelectedPharmacy, SupportFileUpload } from "../../../../store";//FB 7541
import useStyles from "../../../../css/styles";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LoadingButton from "@mui/lab/LoadingButton";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import useMediaQuery from "@mui/material/useMediaQuery";
import {UploadDocumentsFromPortal } from "../../../../api/PE_API";//FB 7541 FB 9372


// Update log
// FB  6192   02/06/2023  DK  Added page to handle patient's records
// FB  7116   07/21/2023  SK  Patient Portal : CCDA title should be renamed to Download Visit Record
// FB  7460   09/25/2023  SK  Ordy Patient Portal issues
// FB  6997   10/09/2023  SK   Patient Portal: All the api's that shows results in the Patient portal needs fine tuning
// FB  7541   10/16/2023  SK  Implementing a feature that allows patients to upload clinical documents via a patient portal
// FB  7704   10/27/2023  SK  Manually Entering Billing Amount is showing error in Print Receipt view and Update Pharmacy is failing in Portal
// FB  8117   02/23/2024  DK  Avoid calling EMR API directly from Portal
// FB  8584   05/14/2024  SK  Portal Loading takes long for multiple tabs
// FB  9372   09/13/2024  GA  Portal UI should not call EMR APIs Directly
// FB  10912  08/25/2025  MK  My Records: Unable to upload any document—the dropdown is blank.


// FB 7541 - Begin
function CircularProgressWithLabel(
  props: CircularProgressProps & { value: number }
) {
  return (
    <Box style={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress
        variant="determinate"
        style={{ color: "#18a2b8" }}
        {...props}
      />
      <Box
        style={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      ></Box>
    </Box>
  );
}
// FB 7541 - End

export default function Myrecord() {
  // FB 7541 - Begin
  const navigate = useNavigate();
  const [documentType, setDocumentType] = useState<any>("");
  const [otherDocument, setOtherDocument] = useState<any>("");
  const [inputList, setInputList] = useState<SupportFileUpload[]>([]);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(true);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [progress, setProgress] = useState(10);
  const [buttonLabel, setButtonLabel] = useState("Cancel");
  const themes = createTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
    },
    overrides: {
      MuiFormLabel: {
        asterisk: {
          color: "red",
        },
      },
    },
  });
  var JSAlert = require("js-alert");
  const [DocumentCategories, setDocumentCategories] = useState([]);
  let patientName = "User";
  let userName: any;
  let data = sessionStorage.getItem("user");
  let id: any;
  let patientid: any;
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
    patientid = JSON.parse(data).EMRID;
  }
  const addInputDocument = (e: any) => {
    const file = e.target.files[0];
    const fileSize = Number((file.size / (1024 * 1024)).toFixed(3));
    if (inputList.some((doc) => doc.FileName === file.name)) {
      JSAlert.alert(
        "File already exists. Please select a different file",
        null,
        JSAlert.Icons.Warning
      );
    } else {
      if (
        (file.type === "application/pdf" ||
          file.type === "image/png" ||
          file.type === "image/jpeg") &&
        fileSize > 0
      ) {
        if (fileSize <= 6) {
          const reader = new FileReader();
          InsertPPLogs(
            "Clicked on Choose file(s) - Upload files",
            window.location.href,
            userName,
            ""
          );
          reader.onload = () => {
            const input = {
              DocumentType: documentType,
              OtherDocument: otherDocument,
              FileName: file.name,
              FileType: file.type,
              FileSize: fileSize,
              Base64EncodedFile: reader.result?.toString().split("base64,")[1],
              Patient_N: Number(patientid),
              previewUrl: URL.createObjectURL(file), //FB 7129
            } as SupportFileUpload;
            setInputList([...inputList, input]);

            setDocumentType("");

            //FB 7129-End
            setOtherDocument("");
            setButtonLabel("Cancel");
          };
          reader.readAsDataURL(file);
        } else {
          JSAlert.alert(
            "Please select a file smaller than 6MB",
            null,
            JSAlert.Icons.Warning
          );
        }
      } else {
        JSAlert.alert(
          "Invalid file type. Please select a valid file",
          null,
          JSAlert.Icons.Warning
        );
      }
    }
  };
  const handleRemoveClick = (index: number) => {
    InsertPPLogs(
      "Clicked on Delete - Upload files",
      window.location.href,
      userName,
      ""
    );
    var alert = new JSAlert(
      "Are you sure you want to delete this file?",
      "",
      JSAlert.Icons.Question
    );
    alert.addButton("Yes").then(function () {
      inputList.splice(index, 1);
      setInputList([...inputList]);
      InsertPPLogs(
        "Clicked on yes - Upload files",
        window.location.href,
        userName,
        ""
      );

    });
    alert.addButton("No").then(function () {
      InsertPPLogs(
        "Clicked on no - Upload files",
        window.location.href,
        userName,
        ""
      );
      return;
    });
    alert.show();
  };
  const submitDocuments = async () => {
    InsertPPLogs(
      "Clicked on Upload to my chart - Upload files",
      window.location.href,
      userName,
      ""
    );
    setDisableSubmit(true);
    setOpenDialog(true);
    const result = await UploadDocumentsFromPortal(inputList, patientid);
    if (result === 200) {
      setOpenDialog(false);
      JSAlert.alert(
        "File(s) uploaded successfully!",
        null,
        JSAlert.Icons.Success
      );
      // setButtonLabel("Done");
      // navigate("/user/home/Myrecord");
      setInputList([]);
      navigate("/user/home/Myrecord");
    } else {
      setOpenDialog(false);
      setDisableSubmit(false);
      setButtonLabel("Cancel");
    }
  };
  const handleDone = () => {
    if (buttonLabel == "Cancel") {
      InsertPPLogs(
        "Clicked on Cancel - Upload files",
        window.location.href,
        userName,
        ""
      );
    } else if (buttonLabel == "Done") {
      InsertPPLogs(
        "Clicked on Done - Upload files",
        window.location.href,
        userName,
        ""
      );
    }
    setInputList([]);
    navigate("/user/home/Myrecord");
  };
  const SelectDocumentType = async (e: any) => {
    setDocumentType(e.target.value);
    InsertPPLogs(
      "Selected the document " + e.target.value,
      window.location.href,
      userName,
      ""
    );
  };

    useEffect(() => {
        GetDocumentCategories().then((data) => {
            let categories = [];

            if (typeof data === "string") {
                // case 1: data is already a comma-separated string
                categories = data.split(",");
            } else if (data && typeof data.DocumentCategories === "string") {
                // case 2: data has a DocumentCategories property
                categories = data.DocumentCategories.split(",");
            }

            setDocumentCategories(categories);
        });
    }, []);

  

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= 100 ? 0 : prevProgress + 10
      );
    }, 800);
    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    inputList.length > 0 ? setDisableSubmit(false) : setDisableSubmit(true);
  }, [inputList]);
  // FB 7541 - End
  const [check, setChecked] = useState(false);
  const matches = useMediaQuery("(min-width:600px)");

  const [search, setSearch] = useState({
    Name: "",
    Address1: "",
    City: "",
    State: "",
    Zip: "",
    Phone: "",
    Fax: "",
  });
  const textField = {
    container: {
      width: "calc(100% - 16px)",
      marginTop: "15px",
    },
  };
  const stylestop = {
    container: {
      width: matches == false ? "250" : "567px",
      border: "1px grey",
      backgroundColor: "white",
      padding: matches == false ? "32px 16px" : "32px 40px",
      height: "206px",
    },
  };
  function handleChange(evt: any) {
    const value = evt.target.value;
    setSearch({
      ...search,
      [evt.target.name]: value,
    });
  }

  async function SelectedValues(evt: any) {
    var SP = {
      PHARMACY_RCOPIAID: evt.RcopiaID,
      PHARMACY_DESCRIPTION:
        "" +
        evt.Name +
        //FB 7460 - Removing Line Break - Begin
        +
        evt.Address1 +
        " Phone:" +
        evt.Phone +
        " Fax:" +
        evt.Fax +
        //FB 7460 - End
        "",
      PHARMACY_NAME: evt.Name,
      PHARMACY_NCPDPID: evt.NCPDPID,
    };

    setPharmaLabel(evt.Name);
    setPharmacycard(false);

    let pharmacyArr: Array<any>;
    let datapharma = sessionStorage.getItem("Pharmacydetails");
    if (datapharma != null) {
      pharmacyArr = JSON.parse(datapharma); //[0].PHARMACY_NAME;
      if (pharmacyArr?.length > 0) {
        pharmacyArr[0].pharmacY_NAME = evt.Name;  //FB 8117
        sessionStorage.setItem("Pharmacydetails", JSON.stringify(pharmacyArr));
      }
    }

    let updatedRec = await UpdatePharmacyDetails(patientid, SP);//FB 7704

    setMedications(updatedRec);
  }

  const styles = useStyles();
  const [medications, setMedications] = useState<Medication[]>();
  const [CCDADocs, setCCDADocs] = useState<CCDA[]>([] as CCDA[]);
  const str = CCDADocs || "";
  const [page_meds, setPage_Meds] = useState(0);
  const [Pharmacycard, setPharmacycard] = useState(false);
  const [rowsPerPage_meds, setRowsPerPage_Meds] = useState(5);
  const [page_ccda, setPage_CCDA] = useState(0);
  const [PharmaLabel, setPharmaLabel] = useState("");
  const [rowsPerPage_ccda, setRowsPerPage_CCDA] = useState(5);
  const [rowsArray, setRowsArray] = useState([5, 10, 15, 20]);
  const [loaderArray, setLoaderArray] = useState<Array<string>>([]);

  const UpdatePharmacy = () => {
    setPharmacycard(true);
  };
  const handleChangeRowsPerPage_Meds = (event: any) => {
    setRowsPerPage_Meds(+event.target.value);
    setPage_Meds(0);
  };
  const handleChangeRowsPerPage_CCDA = (event: any) => {
    setRowsPerPage_CCDA(+event.target.value);
    setPage_CCDA(0);
  };

  // FB 7541 - Included the code on page load
  const [PhName, setPhName] = useState("");
  // FB 7541 - Included the code on page load

  async function GetMeds() {
    var data = sessionStorage.getItem("user");
    if (data != null) {
      const user = JSON.parse(data);
      if (user.Patient_n != null) {
        const data = await GetMedications(user.Patient_n);
        setMedications(data);
      }
    }
    let pharmainfo: any;
    let datapharma = sessionStorage.getItem("Pharmacydetails");
    if (datapharma != null) {
      pharmainfo = JSON.parse(datapharma)[0].pharmacY_NAME; //FB 8117
      setPharmaLabel(pharmainfo);
    }
  }
  const [PharmacyArray, setPharmacyArray] = useState<Array<LogsProps>>([
    {
      Name: "",
      Address1: "",
      City: "",
      State: "",
      Zip: "",
      Phone: "",
      Fax: "",
      ID: "",
    },
  ]);
  const [Pharmacy, setPharmacy] = useState<LogsProps>(
    {
      Name: "",
      Address1: "",
      City: "",
      State: "",
      Zip: "",
      Phone: "",
      Fax: "",
      ID: "",
    },
  );
  type LogsProps = {
    Name: string;
    Address1: string;
    City: string;
    State: string;
    Zip: string;
    Phone: string;
    Fax: string;
    ID: string;
  };
  var JSAlert = require("js-alert");
  const Find = async () => {
    setPharmacyArray([
      {
        Name: "",
        Address1: "",
        City: "",
        State: "",
        Zip: "",
        Phone: "",
        Fax: "",
        ID: "",
      },
    ]);
    setPharmacy({
      Name: "",
      Address1: "",
      City: "",
      State: "",
      Zip: "",
      Phone: "",
      Fax: "",
      ID: "",
    });
    var datapharmacy = await GetPharmacy(
      search.Name,
      search.Address1,
      search.City,
      search.State,
      search.Zip,
      search.Phone,
      search.Fax
    );
    if (datapharmacy.PharmacyList["@count"] === "1") {
      setPharmacy(datapharmacy.PharmacyList.Pharmacy);
    } else {
      setPharmacyArray(datapharmacy.PharmacyList.Pharmacy);
    }

    if (datapharmacy.PharmacyList.Pharmacy == null) {
      JSAlert.alert("No Data Found", null, JSAlert.Icons.Warning);
      setChecked(false);
    } else {
      setChecked(true);
    }
  };

  async function GetCCDADocs() {
    var data = sessionStorage.getItem("user");
    if (data != null) {
      const user = JSON.parse(data);
      if (user.EMRID != null) {
        const data = await GetCCDA(user.EMRID);
        setCCDADocs(data);
      }
    }
  }

  function DownloadCCDA(id: number) {
    const doc = CCDADocs.find((CCDADoc) => CCDADoc.ID == id);
    var xmltext = doc ? doc.XML : "";

    var filename = patientName + "_" + new Date().getTime() + ".xml";
    var element = document.createElement("a");
    var bb = new Blob([xmltext], { type: "text/plain" });

    element.setAttribute("href", window.URL.createObjectURL(bb));
    element.setAttribute("download", filename);

    element.dataset.downloadurl = [
      "text/plain",
      element.download,
      element.href,
    ].join(":");
    element.draggable = true;
    element.classList.add("dragout");

    element.click();
    InsertPPLogs("CCDA Download", window.location.href, userName, "");
  }

  async function DownloadCCDAHTML(id: number) {
    setLoaderArray([...loaderArray, id.toString() + "_HTML"]);
    const data = await GetCCDAHTML(id);
    let base64text = data ? "data:application/pdf;base64," + data : "";

    var filename = patientName + "_" + new Date().getTime() + ".pdf";
    var element = document.createElement("a");

    element.setAttribute("href", base64text);
    element.setAttribute("download", filename);

    element.dataset.downloadurl = [
      "application/pdf",
      element.download,
      element.href,
    ].join(":");
    element.draggable = true;
    element.classList.add("dragout");

    element.click();
    setLoaderArray(loaderArray.filter((la) => la != id.toString() + "_HTML"));
  }

  async function ViewCCDA(id: number) {
    setLoaderArray([...loaderArray, id.toString() + "_View"]);
    const data = await GetCCDAHTML(id);
    let base64text = data ? data : "";

    var binary = window.atob(base64text);
    var len = binary.length;
    var buffer = new ArrayBuffer(len);
    var view = new Uint8Array(buffer);
    for (var i = 0; i < len; i++) {
      view[i] = binary.charCodeAt(i);
    }

    var blob = new Blob([view], { type: "application/pdf" });
    var url = URL.createObjectURL(blob);
    window.open(url);
    setLoaderArray(loaderArray.filter((la) => la != id.toString() + "_View"));
  }

  const handleClose = () => {
    setPharmacycard(false);
    GetMeds();
  };
  const ClearFields = () => {
    setSearch({
      Name: "",
      Address1: "",
      City: "",
      State: "",
      Zip: "",
      Phone: "",
      Fax: "",
    });
  };
  function InsertLogs() {
    InsertPPLogs("My Records", window.location.href, userName, "");
  }

  //FB 6997 - Begin
  const [showSpinner, setShowSpinner] = useState(false);
  const theme = useTheme();
  //FB 6997 - End

  useEffect(() => {
    setShowSpinner(true);//FB 6997
    GetMeds();
    GetCCDADocs();
    InsertLogs();
    //FB 6997 - Begin
    setTimeout(() => {
      setShowSpinner(false);
    }, 3000);
    //FB 8584
    //FB 6997 - End
  }, []);
  const styletwo = {
    container: {
      paddingTop: matches == false ? "" : 10,
      border: "1px grey",
      backgroundColor: "#F5F5F5",
      paddingLeft: matches == false ? "16px" : "",
    },
  };
  return (
    <div>
      {matches && <NavBar />}
      <div
        className="card"
        style={
          matches == false ? stylestopmobile.container : stylestart.container
        }
      >
        {matches && (
          // FB 7541 - Begin
          <div style={{ display: 'flex', alignItems: 'baseline' }}>
            <h2 style={{ textAlign: 'left', fontSize: '32px', fontWeight: 700, lineHeight: '40px' }}>My Records -&nbsp;</h2>
            <p style={{ textAlign: 'left', fontFamily: 'Inter', fontSize: '160%' }}>Medications, Download Visit Records, Upload Documents</p>
          </div>
          // FB 7541 - End
        )}
        {!matches && (
          <div
            className="row"
            style={{
              paddingLeft: "25px",
              paddingTop: "16px",
              backgroundColor: "#F5F5F5",
              fontWeight: "bold",
            }}
          >
            My Record{" "}
            <hr
              style={{
                height: "2px",
                border: "none",
                backgroundColor: "black",
              }}
            ></hr>
          </div>
        )}
        <div className="card" style={styletwo.container}>
          <p
            style={{ textAlign: "left", fontFamily: "Inter", fontSize: "160%" }}
          >
            Medications
          </p>
        </div>
        {medications != null ? (
          <>
            <p
              style={{
                textAlign: "left",
                paddingLeft: matches == false ? "15px" : "0px",
              }}
            >
              {PharmaLabel} {!matches && <br></br>}
              <u
                style={{ color: "blue", cursor: "pointer" }}
                onClick={UpdatePharmacy}
              >
                <strong>Update your pharmacy</strong>{" "}
              </u>
            </p>

            {!matches && (
              <Grid container>
                {medications?.map((elem: any) => (
                  <Grid item xs={12} sm={6} md={3}>
                    <Card>
                      <CardContent>
                        <Typography
                          style={{ color: "#13607C", fontWeight: "bold" }}
                        >
                          {elem.Name}
                        </Typography>
                        <Typography style={{ color: "#13607C" }}>
                          {elem.Strength}
                        </Typography>
                        <Typography style={{ color: "#13607C" }}>
                          <img src={"/Images/Pill.jpg"} />
                          &nbsp;
                          {elem.Dosage}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            )}

            {matches && (
              <TableContainer
                component={Paper}
                sx={{ maxHeight: 400, maxWidth: "80%", borderRadius: 0 }}
              >
                <Table
                  stickyHeader
                  size="small"
                  aria-label="sticky table"
                  style={{ tableLayout: "fixed" }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <b>Medication</b>
                      </TableCell>
                      <TableCell>
                        <b>Strength</b>
                      </TableCell>
                      <TableCell>
                        <b>Dosing</b>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {medications
                      ?.slice(
                        page_meds * rowsPerPage_meds,
                        page_meds * rowsPerPage_meds + rowsPerPage_meds
                      )
                      .map((medication) => {
                        return (
                          <TableRow>
                            <TableCell>{medication.Name}</TableCell>
                            <TableCell>{medication.Strength}</TableCell>
                            <TableCell style={{ color: "#083A4D" }}>
                              <span style={{ verticalAlign: "middle" }}>
                                <img
                                  src={"/Images/Pill.jpg"}
                                  style={{ paddingRight: 5 }}
                                />
                                <b>{medication.Dosage}</b>
                              </span>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            <Box
              sx={{
                flexGrow: 1,
                paddingTop: 2,
                paddingBottom: 2,
                maxWidth: "80%",
              }}
            >
              <Grid container>
                <Grid item xs={8} display="flex">
                  <Grid container spacing={2} alignItems="center">
                    <Grid item>
                      <span className={styles.TablePagination_text}>Show </span>
                    </Grid>
                    <Grid item>
                      <select
                        value={rowsPerPage_meds}
                        onChange={(e) => handleChangeRowsPerPage_Meds(e)}
                        style={{
                          color: "#083A4D",
                          borderRadius: "5px",
                          padding: "8px, 16px, 8px, 16px",
                        }}
                      >
                        {rowsArray.map((rows) => (
                          <option value={rows}>{rows}</option>
                        ))}
                      </select>
                    </Grid>
                    <Grid item>
                      <span className={styles.TablePagination_text}>
                        {" "}
                        per page
                      </span>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={4} className={styles.flexend_Grid}>
                  <IconButton
                    onClick={() => setPage_Meds(page_meds - 1)}
                    disabled={page_meds === 0}
                    style={{ color: page_meds === 0 ? "" : "#083A4D" }}
                  >
                    <PlayCircleOutlineIcon
                      style={{ transform: "rotate(180deg)" }}
                    />
                  </IconButton>
                  <IconButton
                    onClick={() => setPage_Meds(page_meds + 1)}
                    disabled={
                      page_meds >=
                      Math.ceil(
                        (medications ? medications.length : 0) /
                        rowsPerPage_meds
                      ) -
                      1
                    }
                    style={{
                      color:
                        page_meds >=
                          Math.ceil(
                            (medications ? medications.length : 0) /
                            rowsPerPage_meds
                          ) -
                          1
                          ? ""
                          : "#083A4D",
                    }}
                  >
                    <PlayCircleOutlineIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </Box>
          </>
        ) : (
          <div className="col-sm-6">
            <div className="card" style={stylestop.container}>
              {/* <div className="card-body"> */}
              <label
                className="card-text"
                style={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: "24px",
                  letterSpacing: "0em",
                  textAlign: "left",
                  paddingBottom: "91px",
                  paddingTop: "52px",
                  paddingLeft: matches == false ? "16px" : "40px",
                  height: "24px",
                }}
              >
                When your medications are uploaded, you will be able to view
                them here.
              </label>
            </div>
          </div>
        )}
        <br></br>
        <div className="card" style={styletwo.container}>
          <p
            style={{ textAlign: "left", fontFamily: "Inter", fontSize: "160%" }}
          >
            {/* FB 7116 */}{/* FB 7541 */}
            Download Visit Records
          </p>
        </div>
        {str.length >= 1 ? (
          <>
            <TableContainer
              component={Paper}
              sx={{
                maxHeight: 400,
                maxWidth: matches == false ? "auto" : "80%",
                borderRadius: 0,
              }}
            >
              <Table
                stickyHeader
                size="small"
                aria-label="sticky table"
                style={{ tableLayout: "fixed" }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <b>Created date</b>
                    </TableCell>
                    <TableCell>
                      <b>Download as XML</b>
                    </TableCell>
                    <TableCell>
                      <b>Download as PDF</b>
                    </TableCell>
                    <TableCell>
                      {/* FB 7116 */}
                      <b>View Visit Record</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {CCDADocs?.slice(
                    page_ccda * rowsPerPage_ccda,
                    page_ccda * rowsPerPage_ccda + rowsPerPage_ccda
                  ).map((CCDADoc) => {
                    return (
                      <TableRow>
                        <TableCell>
                          {new Date(CCDADoc.Date).toLocaleDateString() + ""}
                        </TableCell>
                        <TableCell>
                          <Tooltip title="Download XML" placement="top-start">
                            <IconButton
                              onClick={() => DownloadCCDA(CCDADoc.ID)}
                            >
                              <DownloadIcon style={{ color: "#083A4D" }} />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                        <TableCell>
                          <Tooltip title="Download PDF" placement="top-start">
                            <LoadingButton
                              loading={
                                loaderArray.indexOf(
                                  CCDADoc.ID.toString() + "_HTML"
                                ) > -1
                              }
                              loadingPosition="center"
                              loadingIndicator={
                                <CircularProgress
                                  size={20}
                                  style={{ color: "#083A4D" }}
                                />
                              }
                              onClick={() => DownloadCCDAHTML(CCDADoc.ID)}
                              startIcon={
                                <DownloadIcon
                                  style={{
                                    color:
                                      loaderArray.indexOf(
                                        CCDADoc.ID.toString() + "_HTML"
                                      ) > -1
                                        ? ""
                                        : "#083A4D",
                                  }}
                                />
                              }
                            />
                          </Tooltip>
                        </TableCell>
                        <TableCell>
                          {/* FB 7116 */}
                          <Tooltip title="View Visit Record" placement="top-start">
                            <LoadingButton
                              loading={
                                loaderArray.indexOf(
                                  CCDADoc.ID.toString() + "_View"
                                ) > -1
                              }
                              loadingPosition="center"
                              loadingIndicator={
                                <CircularProgress
                                  size={20}
                                  style={{ color: "#083A4D" }}
                                />
                              }
                              onClick={() => ViewCCDA(CCDADoc.ID)}
                              startIcon={
                                <VisibilityIcon
                                  style={{
                                    color:
                                      loaderArray.indexOf(
                                        CCDADoc.ID.toString() + "_View"
                                      ) > -1
                                        ? ""
                                        : "#083A4D",
                                  }}
                                />
                              }
                            />
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <Box
              sx={{
                flexGrow: 1,
                paddingTop: 2,
                paddingBottom: 2,
                maxWidth: "80%",
              }}
            >
              <Grid container>
                <Grid item xs={8} display="flex">
                  <Grid container spacing={2} alignItems="center">
                    <Grid item>
                      <span className={styles.TablePagination_text}>Show </span>
                    </Grid>
                    <Grid item>
                      <select
                        value={rowsPerPage_ccda}
                        onChange={(e) => handleChangeRowsPerPage_CCDA(e)}
                        style={{
                          color: "#083A4D",
                          borderRadius: "5px",
                          padding: "8px, 16px, 8px, 16px",
                        }}
                      >
                        {rowsArray.map((rows) => (
                          <option value={rows}>{rows}</option>
                        ))}
                      </select>
                    </Grid>
                    <Grid item>
                      <span className={styles.TablePagination_text}>
                        {" "}
                        per page
                      </span>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={4} className={styles.flexend_Grid}>
                  <IconButton
                    onClick={() => setPage_CCDA(page_ccda - 1)}
                    disabled={page_ccda === 0}
                    style={{ color: page_ccda === 0 ? "" : "#083A4D" }}
                  >
                    <PlayCircleOutlineIcon
                      style={{ transform: "rotate(180deg)" }}
                    />
                  </IconButton>
                  <IconButton
                    onClick={() => setPage_CCDA(page_ccda + 1)}
                    disabled={
                      page_ccda >=
                      Math.ceil(
                        (CCDADocs ? CCDADocs.length : 0) / rowsPerPage_ccda
                      ) -
                      1
                    }
                    style={{
                      color:
                        page_ccda >=
                          Math.ceil(
                            (CCDADocs ? CCDADocs.length : 0) / rowsPerPage_ccda
                          ) -
                          1
                          ? ""
                          : "#083A4D",
                    }}
                  >
                    <PlayCircleOutlineIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </Box>
          </>
        ) : (
          <div className="card" style={stylestop.container}>
            <label
              className="card-text"
              style={{
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: 400,
                lineHeight: "24px",
                letterSpacing: "0em",
                textAlign: "left",
                paddingBottom: "91px",
                paddingTop: "52px",
                paddingLeft: matches == false ? "16px" : "40px",
                height: "24px",
              }}
            >
              {/* FB 7116 */}
              When your Visit Record is available, you will be able to view or
              download them here.
            </label>
          </div>
        )}
        <Dialog
          open={Pharmacycard}
          fullScreen
          style={{ margin: "20px" }}
          onClose={(event, reason) => {
            if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
              // Set 'open' to false, however you would do that with your particular code.
              setPharmacycard(false);
            }
          }}
        >
          <DialogTitle>Find Pharmacy</DialogTitle>

          <DialogContent>
            <div className="row">
              <div className="col-sm-6">
                <form>
                  <TextField
                    label="Name"
                    id="outlined-size-small"
                    size="small"
                    name="Name"
                    value={search.Name}
                    onChange={handleChange}
                    style={textField.container}
                  />

                  <TextField
                    label="Address"
                    id="outlined-size-small"
                    size="small"
                    name="Address1"
                    value={search.Address1}
                    onChange={handleChange}
                    style={textField.container}
                  />
                  <TextField
                    label="City"
                    id="outlined-size-small"
                    size="small"
                    name="City"
                    value={search.City}
                    onChange={handleChange}
                    style={textField.container}
                  />

                  <TextField
                    label="State"
                    id="outlined-size-small"
                    size="small"
                    name="State"
                    value={search.State}
                    onChange={handleChange}
                    style={textField.container}
                  />

                  <TextField
                    label="Zip"
                    id="outlined-size-small"
                    size="small"
                    name="Zip"
                    value={search.Zip}
                    onChange={handleChange}
                    style={textField.container}
                  />

                  <TextField
                    label="Phone"
                    id="outlined-size-small"
                    size="small"
                    name="Phone"
                    value={search.Phone}
                    onChange={handleChange}
                    style={textField.container}
                  />

                  <TextField
                    label="Fax"
                    id="outlined-size-small"
                    size="small"
                    name="Fax"
                    value={search.Fax}
                    onChange={handleChange}
                    style={textField.container}
                  />

                  {/* <label style={label.container}>Name</label>
                  
                  <input
                    type="text"
                    name="Name"
                    value={search.Name}
                    onChange={handleChange}
                    style={textField.container}
                  />
                  <label style={label.container}>Address</label>
                  <input
                    type="text"
                    name="Address1"
                    value={search.Address1}
                    onChange={handleChange}
                    style={textField.container}
                  />
                  <label style={label.container}>City</label>
                  <input
                    type="text"
                    name="City"
                    value={search.City}
                    onChange={handleChange}
                    style={textField.container}
                  />
                  <label style={label.container}>State</label>
                  <input
                    type="text"
                    name="State"
                    value={search.State}
                    onChange={handleChange}
                    style={textField.container}
                  />
                  <label style={label.container}>Zip</label>
                  <input
                    type="text"
                    name="Zip"
                    value={search.Zip}
                    onChange={handleChange}
                    style={textField.container}
                  />
                  <label style={label.container}>Phone</label>
                  <input
                    type="text"
                    name="Phone"
                    value={search.Phone}
                    onChange={handleChange}
                    style={textField.container}
                  />
                  <label style={label.container}>Fax</label>
                  <input
                    type="text"
                    name="Fax"
                    value={search.Fax}
                    onChange={handleChange}
                    style={textField.container}
                  /> */}
                  {check && (
                    <label
                      style={{
                        display: " inline-block",
                        width: " 170px",

                        marginTop: "30px",
                      }}
                    >
                      {/* {PharmacyArray.length} */}
                      Total Results : {Pharmacy.Name != "" ? "1" : PharmacyArray.length}
                    </label>
                  )}
                </form>
              </div>
              <div className="col">
                <div>
                  <button
                    className="btn"
                    style={{
                      backgroundColor: "#13607C",
                      color: "white",
                      width: "150px",
                      marginTop: "15px",
                    }}
                    onClick={Find}
                  >
                    Find Pharmacy
                  </button>
                </div>
                <div>
                  <button
                    className="btn"
                    style={{
                      backgroundColor: "#13607C",
                      color: "white",
                      width: "150px",
                      marginTop: "10px",
                    }}
                    onClick={ClearFields}
                  >
                    Clear Fields
                  </button>
                </div>
                <div>
                  <button
                    className="btn"
                    style={{
                      backgroundColor: "#13607C",
                      color: "white",
                      width: "150px",
                      marginTop: "10px",
                    }}
                    onClick={handleClose}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
            {check && matches && (
              <TableContainer component={Paper} style={{ width: "1250px" }}>
                <Table
                  sx={{ minWidth: 650 }}
                  aria-label="simple table"
                  style={{ cursor: "pointer" }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">
                        <strong>Name</strong>
                      </TableCell>
                      <TableCell align="left">
                        <strong>Address</strong>
                      </TableCell>
                      <TableCell align="left">
                        <strong>City</strong>&nbsp;
                      </TableCell>
                      <TableCell align="left">
                        <strong>State</strong> &nbsp;
                      </TableCell>
                      <TableCell align="left">
                        <strong>Zip </strong>&nbsp;
                      </TableCell>
                      <TableCell align="left">
                        <strong>Phone</strong>&nbsp;
                      </TableCell>
                      <TableCell align="left">
                        <strong>Fax</strong>&nbsp;
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Pharmacy.Name != "" ?
                      <TableRow
                        key={Pharmacy.Name}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        onClick={() => SelectedValues(Pharmacy)}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          align="left"
                          style={{
                            color: "#13607C",
                            textDecoration: "underline",
                          }}
                        >
                          {Pharmacy.Name}
                        </TableCell>
                        <TableCell align="left">{Pharmacy.Address1}</TableCell>
                        <TableCell align="left">{Pharmacy.City}</TableCell>
                        <TableCell align="left">{Pharmacy.State}</TableCell>
                        <TableCell align="left">{Pharmacy.Zip}</TableCell>
                        <TableCell align="left">{Pharmacy.Phone}</TableCell>
                        <TableCell align="left">{Pharmacy.Fax}</TableCell>
                      </TableRow>
                      : PharmacyArray.map((x) => (
                        <TableRow
                          key={x.Name}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                          onClick={() => SelectedValues(x)}
                        >
                          <TableCell
                            component="th"
                            scope="row"
                            align="left"
                            style={{
                              color: "#13607C",
                              textDecoration: "underline",
                            }}
                          >
                            {x.Name}
                          </TableCell>
                          <TableCell align="left">{x.Address1}</TableCell>
                          <TableCell align="left">{x.City}</TableCell>
                          <TableCell align="left">{x.State}</TableCell>
                          <TableCell align="left">{x.Zip}</TableCell>
                          <TableCell align="left">{x.Phone}</TableCell>
                          <TableCell align="left">{x.Fax}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
            {!matches && check && (
              <TableContainer component={Paper} style={{ width: "auto" }}>
                <Table aria-label="simple table" style={{ cursor: "pointer" }}>
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">
                        <strong>Name</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Pharmacy.Name != "" ?
                      <TableRow
                        key={Pharmacy.Name}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        onClick={() => SelectedValues(Pharmacy)}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          align="left"
                          style={{
                            color: "#13607C",
                            textDecoration: "underline",
                          }}
                        >
                          {Pharmacy.Name}
                          <br></br>
                          {Pharmacy.Address1}
                          <br></br>
                          <a
                            href={"tel:" + Pharmacy.Phone}
                            style={{ textDecoration: "none !important" }}
                          >
                            {Pharmacy.Phone}
                          </a>
                          &nbsp;{" "}
                          <Tooltip
                            title={
                              "City: " +
                              Pharmacy.City +
                              ", Zip: " +
                              Pharmacy.Zip +
                              ", Phone:" +
                              Pharmacy.Phone +
                              ", Fax:" +
                              Pharmacy.Fax
                            }
                            enterDelay={500}
                            leaveDelay={200}
                          >
                            <InfoIcon />
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                      : PharmacyArray.map((x) => (
                        <TableRow
                          key={x.Name}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                          onClick={() => SelectedValues(x)}
                        >
                          <TableCell
                            component="th"
                            scope="row"
                            align="left"
                            style={{
                              color: "#13607C",
                              textDecoration: "underline",
                            }}
                          >
                            {x.Name}
                            <br></br>
                            {x.Address1}
                            <br></br>
                            <a
                              href={"tel:" + x.Phone}
                              style={{ textDecoration: "none !important" }}
                            >
                              {x.Phone}
                            </a>
                            &nbsp;{" "}
                            <Tooltip
                              title={
                                "City: " +
                                x.City +
                                ", Zip: " +
                                x.Zip +
                                ", Phone:" +
                                x.Phone +
                                ", Fax:" +
                                x.Fax
                              }
                              enterDelay={500}
                              leaveDelay={200}
                            >
                              <InfoIcon />
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </DialogContent>
        </Dialog>
      </div>
      {/* FB 6997 - Begin */}
      <ThemeProvider theme={theme}>
        <Dialog open={showSpinner} fullWidth maxWidth={"xs"}>
          <DialogContent
            style={{
              display: "flex",
              alignContent: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress style={{ color: "#083A4D" }} />
          </DialogContent>
        </Dialog>
      </ThemeProvider>
      {/* FB 6997 - End */}

      {/* FB 7541 - Begin */}
      <Box
        sx={{
          width: "100%",
          padding: window.innerWidth < 800 ? "24px 20px" : "24px 80px",
          backgroundColor: "#F5F5F5",
        }}
      >
        <Grid
          container
          spacing={2}
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={12}
          >
            <Typography variant="body1" style={{ textAlign: "left", fontFamily: "Inter", fontSize: "160%" }}>
              Upload  Documents
            </Typography>
          </Grid>
        </Grid>

        <div>
          <Grid
            container
            spacing={3}
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "1%",
            }}
          >
            {/* FB 7112  */}

            <Grid item xs={window.innerWidth <= 768 ? 12 : 4}>
              <ThemeProvider theme={theme}>
                <FormControl required fullWidth>
                  <InputLabel id="for_documenttype">Document category</InputLabel>
                  <Select
                    labelId="for_documenttype"
                    value={documentType}
                    //onChange={e => setDocumentType(e.target.value)}
                    onChange={(e) => SelectDocumentType(e)}
                    name="document_type"
                  >
                    {DocumentCategories.map((item: string) => (
                      <MenuItem value={item}> {item} </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </ThemeProvider>
            </Grid>

            <Grid
              item
              xs={window.innerWidth <= 768 ? 12 : 3}//FB 7129
              style={{ display: documentType === "other" ? "block" : "none" }}
            >
              <ThemeProvider theme={themes}>
                <TextField
                  label="Please specify the other document"
                  variant="standard"
                  name="other_document"
                  value={otherDocument}
                  onChange={(e) => setOtherDocument(e.target.value)}
                  fullWidth
                />
              </ThemeProvider>
            </Grid>

            <Grid item xs={window.innerWidth <= 768 ? 12 : 4} style={{ display: "flex", alignItems: "center" }}>{/* FB 7129 */}
              <Button
                variant="contained"
                component="label"
                style={{
                  backgroundColor:documentType.length > 0 ? "#13607C" :"lightGray",
                  color: "white",
                  borderRadius: "10px",
                }}
                disabled={documentType.length > 0 ? false : true}
              >
                Choose File
                <input
                  type="file"
                  name="document_path"
                  onChange={(e) => addInputDocument(e)}
                  onClick={(event) => {
                    event.currentTarget.value = "";
                  }}
                  accept="image/*,.pdf"
                  hidden
                />
              </Button>


              {/* FB 7129-Begin*/}
              <span style={{ marginLeft: "10px", fontSize: "0.85rem" }}>
                <label>(Accepted file types:</label><br />
                <label> pdf, jpg, jpeg, png. Max size: 6 MB)</label>
              </span>
              {/* FB 7129-End*/}
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={documentType === "other" || window.innerWidth <= 768 ? 12 : 8}
            >
              <span style={{ color: "red" }}>* Mandatory fields</span>
            </Grid>
          </Grid>
        </div>

        <div style={{ marginBottom: "inherit" }}>{/* FB 7129 - Deleted unused part of code*/}
          <Grid
            container
            style={{
              display: inputList.length > 0 ? "flex" : "none",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/*FB 4955*/}
            <Grid
              item
              xs={12}// FB 7129
              style={{ marginTop: 10, overflow: "hidden" }}//FB 7129
            >
              <TableContainer >{/* FB 7129 */}
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        colSpan={6}//FB 7129
                        style={{ fontSize: "1.3rem", fontWeight: "bold" }}
                      >
                        Selected files
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontSize: "1rem" }}>
                        Document Category
                      </TableCell>
                      <TableCell style={{ fontSize: "1rem" }}>Name</TableCell>
                      <TableCell style={{ fontSize: "1rem" }}>Size</TableCell>
                      <TableCell style={{ fontSize: "1rem" }}>Preview</TableCell>{/* FB 7129 */}
                      <TableCell style={{ fontSize: "1rem" }}>Tools</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {inputList.map((input, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell>
                            {input.DocumentType === "other"
                              ? input.OtherDocument
                              : input.DocumentType}
                          </TableCell>
                          <TableCell>{input.FileName}</TableCell>
                          <TableCell>{input.FileSize + " MB"}</TableCell>
                          {/* FB 7129-Begin*/}
                          <TableCell>{input.FileType.includes('image') ? (
                            <img
                              src={input.previewUrl}
                              alt={`Preview ${index + 1}`}
                              style={{ maxWidth: '50%', height: 'auto' }}
                            />
                          ) : (
                            <embed src={input.previewUrl} type="application/pdf" width="100%" height="600px" />
                          )}</TableCell>
                          {/* FB 7129-End */}

                          <TableCell>
                            <Tooltip title="Delete">
                              <IconButton
                                aria-label="delete"
                                onClick={() => handleRemoveClick(index)}
                                size="small"
                              >
                                <Delete fontSize="small" color="error" />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </div>
        {/* FB 7129 - Begin */}
        <Grid container spacing={3} className={styles.flexend_Grid}>
          <Grid
            style={{
              margin: "25px"
            }}
          >{/* FB 7129- End*/}
            <Button
              onClick={submitDocuments}
              variant="contained"
              id="submit"
              className={styles.navigationButton}
              style={{ display: disableSubmit ? "none" : "", marginRight: "5px" }}//FB 7129
            >
              Upload to my chart
            </Button>
            {/* FB 7129 - Deleted unused part of code*/}
            <Button
              variant="contained"
              className={styles.navigationButton}
              onClick={handleDone}
              style={{ width: 100 }}
            >
              {buttonLabel}
            </Button>
          </Grid>
        </Grid>

        <Dialog open={openDialog} disableBackdropClick fullWidth maxWidth={"xs"}>
          <DialogTitle
            style={{
              display: "flex",
              alignContent: "center",
              justifyContent: "center",
            }}
          >
            <Typography style={{ color: "#18a2b8" }}>Uploading...</Typography>
          </DialogTitle>
          <DialogContent
            style={{
              display: "flex",
              alignContent: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgressWithLabel value={progress} />
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </Box>
      {/* FB 7541 - End */}
    </div>
  );
}

const button = {
  container: {
    backgroundColor: "#13607C",
    color: "white",
  },
};
const stylestopmobile = {
  container: {
    border: "1px grey",
    backgroundColor: "#F5F5F5",
    marginBottom: "20px",
  },
};
const stylestart = {
  container: {
    border: "1px grey",
    paddingLeft: "80px",
    backgroundColor: "#F5F5F5",
    paddingTop: "20px",
  },
};
// FB 7541

const table = {
  container: {
    margin: "20px",
    border: "white",
  },
};
const select1 = {
  container: {
    height: "35px",
    width: "205px",
    borderRadius: "1px",
    marginLeft: "85px",
  },
};

const select = {
  container: {
    height: "35px",
    width: "205px",
    borderRadius: "1px",
    marginLeft: "50px",
  },
};
const label = {
  container: {
    display: " inline-block",
    width: " 120px",
    alignText: "right",
    marginTop: "10px",
  },
};